import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import { ProductTypeActions, ProductTypeStore, STATUS } from 'Stores/productTypeStore'
import { priorities } from '../../stores/productTypeStore'

export default class ProductTypeList extends Component {
  constructor(props) {
    super(props)
    this.stores = [ProductTypeStore]
    this.storeKeys = ['productTypes', 'status']
  }

  componentDidMount() {
    ProductTypeActions.getProductTypes()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching ProductTypes Failed', {
        autoClose: 7500,
        onClose: () => {
          ProductTypeActions.clearToast()
        }
      })
      ProductTypeActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Delete ProductType Failed', {
        autoClose: 7500,
        onClose: () => {
          ProductTypeActions.clearToast()
        }
      })
      ProductTypeActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('ProductType Deleted', {
        autoClose: 7500,
        onClose: () => {
          ProductTypeActions.clearToast()
        }
      })
      ProductTypeActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <CollapsibleCard startOpen header={<strong>ProductTypes</strong>}>
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'ProductTypeID'
            },
            fieldFunctions: {
              bodyText: e => {
                if (e.bodyText) {
                  const maxStringLength = 100
                  let shownText = e.bodyText.substring(0, maxStringLength)
                  if (e.bodyText.length > maxStringLength) {
                    shownText += '...'
                  }
                  return shownText
                }
              },
              poolOrder: e => {
                return priorities[e.poolOrder / 10]
              },
              timeStart: e => {
                if (e.timeStart) {
                  return moment(e.timeStart).format('DD-MM-YYYY ')
                }
              },
              timeEnd: e => {
                if (e.timeEnd) {
                  return moment(e.timeEnd).format('DD-MM-YYYY')
                }
              }
            },
            fieldStringFunctions: {
              poolOrder: e => {
                return e.poolOrder
              },
              timeStart: e => {
                return moment(e.timeStart).format('x')
              },
              timeEnd: e => {
                return moment(e.timeEnd).format('x')
              }
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Tooltip target={'edit' + e.ProductTypeID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/product-types/' + e.ProductTypeID} id={'edit' + e.ProductTypeID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Tooltip target={'delete' + e.ProductTypeID}>Slet</Tooltip>
                    <Button
                      id={'delete' + e.ProductTypeID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Vil du slette denne produkttype?')) {
                          ProductTypeActions.deleteProductType(e.ProductTypeID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            ProductTypeID: 'ID',
            name: 'Name'
          }}
          data={this.state.productTypes}
        />
      </CollapsibleCard>
    )
  }
}
